import React, { MouseEvent, useEffect, useRef, useState } from "react";
import HeaderButton from "./HeaderButton";
import "./HeaderDropDownButton.css";

export interface IconDisplayValue<T> {
  icon: React.ReactNode | null | undefined;
  display: string;
  value: T;
  disabled: boolean;
}

type Props<T> = {
  icon: React.ReactNode;
  label: string;
  id: string;
  onChange: (value: T) => void;
  iconDisplayValues: IconDisplayValue<T>[];
  style?: React.CSSProperties;
  dropDownStyle?: React.CSSProperties;
  disabled?: boolean;
};

type DropDownProps = {
  options: React.ReactNode;
  onBlur: () => void;
  style?: React.CSSProperties;
};

// const isNodeInsideParent = (node: Node, parent: Node) => {
//   let checkDom: Node | null = node;
//   while (checkDom) {
//     if ((checkDom as Element).innerHTML === (parent as Element).innerHTML) {
//       return true;
//     }
//     checkDom = checkDom.parentNode;
//   }
//   return false;
// };

const isDomParent = (child: Node, parent: Node) => {
  return parent.contains(child) || parent.parentNode?.contains(child);
};

const DropDownButtons = ({ options, onBlur = () => {}, style = {} }: DropDownProps) => {
  const container = useRef(null);

  const onOutsieClicked = (event: MouseEvent) => {
    const containerDom = container.current ? (container.current as unknown) : {};
    const targetDom = event.target;
    const check = isDomParent(targetDom as Node, containerDom as Node);
    if (check) {
      event.preventDefault();
    } else {
      onBlur();
    }
  };

  const savedHandler = useRef(onOutsieClicked);

  useEffect(() => {
    const eventListener = (event: any) => savedHandler.current(event);
    document.addEventListener("mousedown", eventListener);
    return () => document.removeEventListener("mousedown", eventListener);
  }, []);

  return (
    <div className={"dropdown-container dropdown-active"} ref={container} style={style}>
      {options}
    </div>
  );
};

export default function HeaderDropDownButton<T extends string | number>({
  icon,
  label,
  id,
  onChange,
  iconDisplayValues,
  style = {},
  dropDownStyle = {},
  disabled = false,
}: Props<T>) {
  const [open, setOpen] = useState(false);

  const options = iconDisplayValues.map((dropDown) => {
    let itemClass = "header-button-dropdown-item";
    if (dropDown.disabled) {
      itemClass += " disabled";
    }
    return (
      <div
        key={`dropdown-${dropDown.value}`}
        className={itemClass}
        onClick={() => {
          if (!dropDown.disabled) {
            setOpen(false);
            onChange(dropDown.value);
          }
        }}
      >
        <div className="icon-container">{dropDown.icon}</div>
        <div className="text-container">
          <p>{dropDown.display}</p>
        </div>
      </div>
    );
  });

  const onClickContainer = () => {
    console.log("onClickContainer", { open });
    setOpen(!open);
  };

  const onBlur = () => {
    console.log("onBlur");
    setOpen(false);
  };

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <HeaderButton
        icon={icon}
        label={label}
        id={id}
        key={id + "container"}
        onClick={onClickContainer}
        moreAction={true}
        style={style}
        disabled={disabled}
      />
      {open && <DropDownButtons options={options} onBlur={onBlur} style={dropDownStyle} />}
    </div>
  );
}
